
























import { Vue, Component } from 'vue-property-decorator';
import { $asset } from '@/axios';
import { setUserToken } from '@/utils/qtweb';
import MainSideBar from '@/components/layout/MainSideBar.vue';
import MainTopBar from '@/components/layout/MainTopBar.vue';
import MainView from '@/components/layout/MainView.vue';
import Toast from '@/components/widget/Toast.vue';
import AppUpdateToast from '@/components/widget/AppUpdateToast.vue';

@Component({
  components: { MainSideBar, MainTopBar, MainView, Toast, AppUpdateToast },
})
export default class App extends Vue {
  public needUpdate = false;
  public localVersion = '';
  public timer: any = null;
  public checkInterval = 1000 * 60 * 60 * 2;  // 检测更新的间隔

  public async created() {
    // 注册全局函数，供qt web view 里使用
    window.delight = {} as any;
    window.delight.setUserToken = setUserToken;
    document.addEventListener('visibilitychange', this.pageVisibility);
  }

  public beforeDestroy() {
    document.removeEventListener('visibilitychange', this.pageVisibility);
  }

  // 初始化获取 index.html 上的'编译版本号'
  public mounted() {
    const metaTag = document.head.querySelector('meta[name="buildVersion"]');
    this.localVersion = metaTag?.getAttribute('content') || '';

    this.timer = setInterval(() => {
      this.showUpdate();
    }, this.checkInterval);
  }

  // 是否显示版本更新提示
  public async showUpdate() {
    try {
      const version = await $asset('static', 'version.json', { ignoreError: true });
      this.needUpdate = (version !== this.localVersion);
    } catch (e) {
      // 如果请求异常，则表示是最新的，不弹出更新提示
      this.needUpdate = false;
    }
  }

  // 浏览器的标签页被激活时，检查版本更新
  public pageVisibility() {
    if (!document.hidden) {
      this.showUpdate();
    }
  }
}
